import { DateTime } from 'luxon';
import { generateGuid } from '../../helpers/guid';
import { LicenseTachoModule } from '../modules/LicenseTachoModule';
import { PaymentStatus, PaymentStatusEnum } from './PaymentStatus';
import { LicenseType, LicenseTypeEnum } from './LicenseType';

export type GenerateLicenseModel = {
    frontId: string;
    validFrom: DateTime;
    validTo: DateTime;
    paymentDeadline: DateTime;
    maximumNumberOfSupportedCars: number;
    clientId: string;
    sendLicenseToTheClientEmail: boolean;
    allowedModules: Array<LicenseTachoModule>;
    paymentStatus: PaymentStatusEnum;
    type: LicenseTypeEnum;
    isServiceEdition: boolean;
    noCarsLimit?: boolean;
    includeBeta?: boolean;
    notes: string;
    distributorId?: string | null;
};

export type GenerateLicenseModelApi = {
    validFrom: string;
    validTo: string;
    paymentDeadline: string;
    maximumNumberOfSupportedCars: number;
    clientId: string;
    sendLicenseToTheClientEmail: boolean;
    allowedModules: Array<LicenseTachoModule>;
    paymentStatus: PaymentStatus;
    licenceType: LicenseType;
    isServiceEdition: boolean;
    notes: string;
    distributorId?: string | null;
};

export const defaultGenerateLicenseModel: GenerateLicenseModel = {
    frontId: generateGuid(),
    validFrom: DateTime.fromISO(''),
    validTo: DateTime.fromISO(''),
    paymentDeadline: DateTime.fromISO(''),
    maximumNumberOfSupportedCars: 1,
    clientId: '',
    sendLicenseToTheClientEmail: false,
    allowedModules: [],
    paymentStatus: PaymentStatusEnum.Awaiting,
    type: LicenseTypeEnum.Commercial,
    isServiceEdition: false,
    notes: '',
    distributorId: null,
};
